import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import TasksView from '../views/TasksView.vue'
import DevicesView from '../views/DevicesView.vue'
import LoginView from '../views/LoginView.vue'
import FinanceView from '../views/FinanceView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  // {
  //   path: '/tasks',
  //   name: 'Tasks',
  //   component: TasksView
  // },
  {
    path: '/tasks/:listName?',
    name: 'Tasks',
    component: TasksView
  },
  {
    path: '/finance',
    name: 'Finance',
    component: FinanceView
  },
  {
    path: '/devices',
    name: 'Devices',
    component: DevicesView
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/items',
    name: 'Items',
    component: () => import('../views/ItemsView.vue')
  },
  {
    path: '/locations',
    name: 'Locations',
    component: () => import('../views/LocationsView.vue')
  },
  {
    path: '/stock',
    name: 'ItemsStock',
    component: () => import('../views/ItemsStockView.vue')
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../views/TestView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach((to, from, next) => {
  const publicPages = ['/login','/test','/train']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem('access_token')

  if (authRequired && !loggedIn) {
    return next('/login')
  }

  next()
})

export default router